'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Title;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function Title(_ref) {
  var text = _ref.text;

  if (typeof text === 'string') {
    return _react2["default"].createElement('h1', {
      className: 'rainbow-notification_title'
    }, text);
  }

  return text;
}

Title.propTypes = {
  text: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].node])
};
Title.defaultProps = {
  text: null
};